import { PointPureUpdateMutationInput, usePointUpdateMutation } from '@shared/api/graphql/generated';
import { FetchPolicyKeys } from '@shared/api/graphql/types';

import usePoint from './usePoint';

const usePointUpdate = () => {
  const [mutation, mutationResult] = usePointUpdateMutation({
    fetchPolicy: FetchPolicyKeys.NETWORK_ONLY,
  });

  const { getPoint } = usePoint();

  const request = async ({
    pointId,
    timezone,
    comment,
    amplifyTrack,
    amplifyPromo,
    amplifyInstant,
    address,
    volume,
    withMusicCut,
    cutDuration,
    fileFormat,
    adOverlapResolution,
  }: PointPureUpdateMutationInput) => {
    const mutationResult = await mutation({
      variables: {
        input: {
          pointId,
          timezone,
          comment,
          amplifyTrack,
          amplifyPromo,
          amplifyInstant,
          address,
          volume,
          withMusicCut,
          cutDuration,
          fileFormat,
          adOverlapResolution,
        },
      },
    });

    const isOk = !!mutationResult.data?.pointPureUpdate?.ok;

    await getPoint(pointId);

    return isOk;
  };

  return {
    error: mutationResult.error,
    loading: mutationResult.loading,
    called: mutationResult.called,
    request,
  };
};

export default usePointUpdate;
